import { render, staticRenderFns } from "./JSelectDepart.vue?vue&type=template&id=71a1f640&scoped=true"
import script from "./JSelectDepart.vue?vue&type=script&lang=js"
export * from "./JSelectDepart.vue?vue&type=script&lang=js"
import style0 from "./JSelectDepart.vue?vue&type=style&index=0&id=71a1f640&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a1f640",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71a1f640')) {
      api.createRecord('71a1f640', component.options)
    } else {
      api.reload('71a1f640', component.options)
    }
    module.hot.accept("./JSelectDepart.vue?vue&type=template&id=71a1f640&scoped=true", function () {
      api.rerender('71a1f640', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecgbiz/JSelectDepart.vue"
export default component.exports